import axios from "axios";
import authHeader from "./auth-header";

import { API_URL } from "./constants";

class ShippingsService {
  createShippingRecordsInDhl(data) {
    return axios.post(API_URL + "shippings/create", data, {
      headers: authHeader(),
    });
  }

  downloadShippingLabelsAsZip(data) {
    return axios({
      url: API_URL + "shippings/dowload-labels-zip",
      method: "POST",
      responseType: "blob",
      data,
      headers: authHeader(),
    });
  }

  reprintShippingLabelsFromDhl(data) {
    return axios.post(API_URL + "shippings/reprint-labels", data, {
      headers: authHeader(),
    });
  }

  deleteShippingFromDhl(data) {
    return axios.post(API_URL + "shippings/delete-shipping-from-dhl", data, {
      headers: authHeader(),
    });
  }
}

export default new ShippingsService();
